/**
 * 用户模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

export const addTeam = (params) => {
  return req.post('/manage/team/addTeam', params);
}
export const teamList = (params) => {
  return req.get('/manage/team/teamList', params);
}
export const teamDetail = (params) => {
  return req.get('/manage/team/teamDetail', params);
}
export const deleteTeam = (params) => {
  return req.post('/manage/team/deleteTeam', params);
}
// 查询医生领导负责的工作室
export const getHeadUpTeam = (params) => {
  return req.get('/api/team/list/leader', params);
}

// 查询医生能转诊的医生列表
export const getTeamReferralDoctorList = (params) => {
  return req.get('/team/user/referral/doctor/list', params);
}

// 转正给团队医生
export const setOrderReferral = (params) => {
  return req.post('/order/info/referral', params);
}
export const doctorTeamOptionsList = (params) => {
  return req.get(`/api/team/list/doctor`, params);
}

export const getTeamList = (params) => {
  return req.get(`/api/team/apiTeamList`, params);
}